import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getNetSales } from '../services/user'

const initialState = {
  EXCELLENCE_IN_FOUNDATIONAL_SKILLSloading: false,
  EXCELLENCE_IN_FOUNDATIONAL_SKILLS: [],

  CAREER_EMPOWERMENT_PREPARATIONloading: false,
  CAREER_EMPOWERMENT_PREPARATION: [],

  SUCCESS_FOR_EVERY_STUDENTloading: false,
  SUCCESS_FOR_EVERY_STUDENT: [],

  GREAT_EDUCATORS_IN_EVERY_SCHOOLloading: false,
  GREAT_EDUCATORS_IN_EVERY_SCHOOL: [],

  Search_filter_Annual_planloading: false,
  Search_filter_Annual_plan: [],

  Excellence_Trend_Chartloading: false,
  Excellence_Trend_Chart: [],

  CAREER_Trend_Chartloading: false,
  CAREER_Trend_Chart: [],

  Success_Trend_Chartloading: false,
  Success_Trend_Chart: [],

  Great_Trend_Chartloading: false,
  Great_Trend_Chart: [],

  Time_Trendloading: false,
  Time_Trend: [],

  Dimension_Trendloading: false,
  Dimension_Trend: [],

  Popup_School_typeloading: false,
  Popup_School_type: [],

  Popup_Top_tileloading: false,
  Popup_Top_tile: [],


}

export const fetchEXCELLENCE_IN_FOUNDATIONAL_SKILLS = createAsyncThunk(
  'fetchEXCELLENCE_IN_FOUNDATIONAL_SKILLS',
  async (EXCELLENCE_IN_FOUNDATIONAL_SKILLS, thunkAPI) => {
    EXCELLENCE_IN_FOUNDATIONAL_SKILLS = { ...EXCELLENCE_IN_FOUNDATIONAL_SKILLS, elasticQueryName: "EXCELLENCE_IN_FOUNDATIONAL_SKILLS" }
    const response = await getNetSales(EXCELLENCE_IN_FOUNDATIONAL_SKILLS);
    return response.data
  }
)

export const fetchCAREER_EMPOWERMENT_PREPARATION = createAsyncThunk(
  'fetchCAREER_EMPOWERMENT_PREPARATION',
  async (CAREER_EMPOWERMENT_PREPARATION, thunkAPI) => {
    CAREER_EMPOWERMENT_PREPARATION = { ...CAREER_EMPOWERMENT_PREPARATION, elasticQueryName: "CAREER_EMPOWERMENT_PREPARATION" }
    const response = await getNetSales(CAREER_EMPOWERMENT_PREPARATION);
    return response.data
  }
)

export const fetchSUCCESS_FOR_EVERY_STUDENT = createAsyncThunk(
  'fetchSUCCESS_FOR_EVERY_STUDENT',
  async (SUCCESS_FOR_EVERY_STUDENT, thunkAPI) => {
    SUCCESS_FOR_EVERY_STUDENT = { ...SUCCESS_FOR_EVERY_STUDENT, elasticQueryName: "SUCCESS_FOR_EVERY_STUDENT" }
    const response = await getNetSales(SUCCESS_FOR_EVERY_STUDENT);
    return response.data
  }
)


export const fetchGREAT_EDUCATORS_IN_EVERY_SCHOOL = createAsyncThunk(
  'fetchGREAT_EDUCATORS_IN_EVERY_SCHOOL',
  async (GREAT_EDUCATORS_IN_EVERY_SCHOOL, thunkAPI) => {
    GREAT_EDUCATORS_IN_EVERY_SCHOOL = { ...GREAT_EDUCATORS_IN_EVERY_SCHOOL, elasticQueryName: "GREAT_EDUCATORS_IN_EVERY_SCHOOL" }
    const response = await getNetSales(GREAT_EDUCATORS_IN_EVERY_SCHOOL);
    return response.data
  }
)

export const fetchSearch_filter_Annual_plan = createAsyncThunk(
  'fetchSearch_filter_Annual_plan',
  async (Search_filter_Annual_plan, thunkAPI) => {
    Search_filter_Annual_plan = { ...Search_filter_Annual_plan, elasticQueryName: "Search_filter_Annual_plan" }
    const response = await getNetSales(Search_filter_Annual_plan);
    return response.data
  }
)

export const fetchExcellence_Trend_Chart = createAsyncThunk(
  'fetchExcellence_Trend_Chart',
  async ({ id, ...Excellence_Trend_Chart }, thunkAPI) => {
    Excellence_Trend_Chart = { ...Excellence_Trend_Chart, elasticQueryName: "Excellence_Trend_Chart" }
    const response = await getNetSales(Excellence_Trend_Chart);
    if (id) return { id, data: response.data }
    return response.data
  }
)

export const fetchCAREER_Trend_Chart = createAsyncThunk(
  'fetchCAREER_Trend_Chart',
  async ({ id, ...CAREER_Trend_Chart }, thunkAPI) => {
    CAREER_Trend_Chart = { ...CAREER_Trend_Chart, elasticQueryName: "CAREER_Trend_Chart" }
    const response = await getNetSales(CAREER_Trend_Chart);
    if (id) return { id, data: response.data }
    return response.data
  }
)

export const fetchSuccess_Trend_Chart = createAsyncThunk(
  'fetchSuccess_Trend_Chart',
  async ({ id, ...Success_Trend_Chart }, thunkAPI) => {
    Success_Trend_Chart = { ...Success_Trend_Chart, elasticQueryName: "Success_Trend_Chart" }
    const response = await getNetSales(Success_Trend_Chart);
    if (id) return { id, data: response.data }
    return response.data
  }
)

export const fetchGreat_Trend_Chart = createAsyncThunk(
  'fetchGreat_Trend_Chart',
  async ({ id, ...Great_Trend_Chart }, thunkAPI) => {
    Great_Trend_Chart = { ...Great_Trend_Chart, elasticQueryName: "Great_Trend_Chart" }
    const response = await getNetSales(Great_Trend_Chart);
    if (id) return { id, data: response.data }
    return response.data
  }
)

export const fetchTime_Trend = createAsyncThunk(
  'fetchTime_Trend',
  async (Time_Trend, thunkAPI) => {
    Time_Trend = { ...Time_Trend, elasticQueryName: "Time_Trend" }
    const response = await getNetSales(Time_Trend);
    return response.data
  }
)

export const fetchDimension_Trend = createAsyncThunk(
  'fetchDimension_Trend',
  async (Dimension_Trend, thunkAPI) => {
    Dimension_Trend = { ...Dimension_Trend, elasticQueryName: "Dimension_Trend" }
    const response = await getNetSales(Dimension_Trend);
    return response.data
  }
)

export const fetchPopup_School_type = createAsyncThunk(
  'fetchPopup_School_type',
  async (Popup_School_type, thunkAPI) => {
    Popup_School_type = { ...Popup_School_type, elasticQueryName: "Popup_School_type" }
    const response = await getNetSales(Popup_School_type);
    return response.data
  }
)

export const fetchPopup_Top_tile = createAsyncThunk(
  'fetchPopup_Top_tile',
  async (Popup_Top_tile, thunkAPI) => {
    Popup_Top_tile = { ...Popup_Top_tile, elasticQueryName: "Popup_Top_tile" }
    const response = await getNetSales(Popup_Top_tile);
    return response.data
  }
)

export const annualplandashboard = createSlice({
  name: 'annualplandashboard',
  initialState,
  reducers: {
    setstate: (state, action) => {
      return {
        ...state,
        ...action.payload
      }
    },
    removestate: (state, action) => {
      const newState = { ...state }; // Shallow copy
      delete newState[action.payload]; // Remove the key
      return newState;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEXCELLENCE_IN_FOUNDATIONAL_SKILLS.fulfilled, (state, action) => {
      state.EXCELLENCE_IN_FOUNDATIONAL_SKILLS = action.payload;
      state.EXCELLENCE_IN_FOUNDATIONAL_SKILLSloading = false;
    }).addCase(fetchEXCELLENCE_IN_FOUNDATIONAL_SKILLS.pending, (state, action) => {
      state.EXCELLENCE_IN_FOUNDATIONAL_SKILLSloading = true;
    })

    builder.addCase(fetchCAREER_EMPOWERMENT_PREPARATION.fulfilled, (state, action) => {
      state.CAREER_EMPOWERMENT_PREPARATION = action.payload;
      state.CAREER_EMPOWERMENT_PREPARATIONloading = false;
    }).addCase(fetchCAREER_EMPOWERMENT_PREPARATION.pending, (state, action) => {
      state.CAREER_EMPOWERMENT_PREPARATIONloading = true;
    })

    builder.addCase(fetchSUCCESS_FOR_EVERY_STUDENT.fulfilled, (state, action) => {
      state.SUCCESS_FOR_EVERY_STUDENT = action.payload;
      state.SUCCESS_FOR_EVERY_STUDENTloading = false;
    }).addCase(fetchSUCCESS_FOR_EVERY_STUDENT.pending, (state, action) => {
      state.SUCCESS_FOR_EVERY_STUDENTloading = true;
    })

    builder.addCase(fetchGREAT_EDUCATORS_IN_EVERY_SCHOOL.fulfilled, (state, action) => {
      state.GREAT_EDUCATORS_IN_EVERY_SCHOOLloading = false;
      state.GREAT_EDUCATORS_IN_EVERY_SCHOOL = action.payload;
    }).addCase(fetchGREAT_EDUCATORS_IN_EVERY_SCHOOL.pending, (state, action) => {
      state.GREAT_EDUCATORS_IN_EVERY_SCHOOLloading = true;
    })

    builder.addCase(fetchSearch_filter_Annual_plan.fulfilled, (state, action) => {
      state.Search_filter_Annual_planloading = false;
      state.Search_filter_Annual_plan = action.payload;
    }).addCase(fetchSearch_filter_Annual_plan.pending, (state, action) => {
      state.Search_filter_Annual_planloading = true;
    })

    builder.addCase(fetchExcellence_Trend_Chart.fulfilled, (state, action) => {
      if (action.payload?.id) {
        state[`Excellence_Trend_Chart${action.payload?.id}`] = action.payload.data;
        state[`Excellence_Trend_Chart${action.payload?.id}loading`] = false;
      } else {
        state.Excellence_Trend_Chart = action.payload;
        state.Excellence_Trend_Chartloading = false;
      }
    }).addCase(fetchExcellence_Trend_Chart.pending, (state, action) => {
      if (action.payload?.id) {
        state[`Excellence_Trend_Chart${action.payload?.id}loading`] = true;
      } else {
        state.Excellence_Trend_Chartloading = true;
      }
    })

    builder.addCase(fetchCAREER_Trend_Chart.fulfilled, (state, action) => {
      if (action.payload?.id) {
        state[`CAREER_Trend_Chart${action.payload?.id}`] = action.payload.data;
        state[`CAREER_Trend_Chart${action.payload?.id}loading`] = false;
      } else {
        state.CAREER_Trend_Chart = action.payload;
        state.CAREER_Trend_Chartloading = false;
      }
    }).addCase(fetchCAREER_Trend_Chart.pending, (state, action) => {
      if (action.payload?.id) {
        state[`CAREER_Trend_Chart${action.payload?.id}loading`] = true;
      } else {
        state.CAREER_Trend_Chartloading = true;
      }
    })

    builder.addCase(fetchSuccess_Trend_Chart.fulfilled, (state, action) => {
      if (action.payload?.id) {
        state[`Success_Trend_Chart${action.payload?.id}`] = action.payload.data;
        state[`Success_Trend_Chart${action.payload?.id}loading`] = false;
      } else {
        state.Success_Trend_Chart = action.payload;
        state.Success_Trend_Chartloading = false;
      }
    }).addCase(fetchSuccess_Trend_Chart.pending, (state, action) => {
      if (action.payload?.id) {
        state[`Success_Trend_Chart${action.payload?.id}loading`] = true;
      } else {
        state.Success_Trend_Chartloading = true;
      }
    })

    builder.addCase(fetchGreat_Trend_Chart.fulfilled, (state, action) => {
      if (action.payload?.id) {
        state[`Great_Trend_Chart${action.payload?.id}`] = action.payload.data;
        state[`Great_Trend_Chart${action.payload?.id}loading`] = false;
      } else {
        state.Great_Trend_Chart = action.payload;
        state.Great_Trend_Chartloading = false;
      }
    }).addCase(fetchGreat_Trend_Chart.pending, (state, action) => {
      if (action.payload?.id) {
        state[`Great_Trend_Chart${action.payload?.id}loading`] = true;
      } else {
        state.Great_Trend_Chartloading = true;
      }
    })

    builder.addCase(fetchTime_Trend.fulfilled, (state, action) => {
      state.Time_Trendloading = false;
      state.Time_Trend = action.payload;
    }).addCase(fetchTime_Trend.pending, (state, action) => {
      state.Time_Trendloading = true;
    })

    builder.addCase(fetchDimension_Trend.fulfilled, (state, action) => {
      state.Dimension_Trendloading = false;
      state.Dimension_Trend = action.payload;
    }).addCase(fetchDimension_Trend.pending, (state, action) => {
      state.Dimension_Trendloading = true;
    })

    builder.addCase(fetchPopup_School_type.fulfilled, (state, action) => {
      state.Popup_School_typeloading = false;
      state.Popup_School_type = action.payload;
    }).addCase(fetchPopup_School_type.pending, (state, action) => {
      state.Popup_School_typeloading = true;
    })

    builder.addCase(fetchPopup_Top_tile.fulfilled, (state, action) => {
      state.Popup_Top_tile = action.payload;
      state.Popup_Top_tileloading = false;
    }).addCase(fetchPopup_Top_tile.pending, (state, action) => {
      state.Popup_Top_tileloading = true;
    })



  }
})

// Action creators are generated for each case reducer function
export const { setstate, removestate } = annualplandashboard.actions

export default annualplandashboard.reducer